export const ETaskStatus = {
   0: "UNKNOWN",
   1: "OPEN",
   2: "CLOSED",
   "-1": "ALL",
};

export const ETaskSubStatus = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "NEW",
   2: "PROCESSING",
   3: "WAITING_ON_OPERATOR",
   4: "WAITING_ON_PROVIDER",
   5: "WAITING_ON_AGENCY",
   6: "CLOSED",
   7: "REPLIED_BY_PROVIDER",
   8: "REPLIED_BY_AGENCY",
   9: "REOPEN",
};

export const ETaskType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "PNR_REVERSE",
   2: "PNR_REISSUE",
   3: "PNR_ANCILLARY",
   4: "PNR_CORRECTION",
   5: "PNR_DIVIDE",
   6: "PNR_OPEN",
   7: "PNR_ADD",
   8: "PNR_UPDATE",
   9: "PNR_UPDATE_PAX",
   10: "PNR_QUEUE_SCAN",
   11: "PNR_FLIGHT_CHANGE_CONFIRMATION",
   21: "VOUCHER_REVERSE",
   22: "VOUCHER_REISSUE",
   23: "VOUCHER_ADD",
   24: "VOUCHER_NOTE",
   25: "VOUCHER_UPDATE",
   26: "VOUCHER_RECONFIRMATION",
   41: "TNR_ADD",
   42: "TNR_REVERSE",
   43: "TNR_REISSUE",
   61: "PAYMENT_REVERSE",
   81: "RNR_ADD",
   82: "RNR_REVERSE",
   83: "RNR_REISSUE",
   84: "RNR_ANCILLARY",
   85: "RNR_UPDATE_DRIVER",
   86: "RNR_NOTE",
   101: "PACKAGE_INFO",
};
export const ETaskSubType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "BASIC",
   2: "FLIGHT_CHANGE_CONFIRM_MINOR",
   3: "FLIGHT_CHANGE_CONFIRM_MAJOR",
   116: "PNR_QUEUE_Q16_VENDOR_REMARKS",
   121: "PNR_QUEUE_Q21_UNABLE_TO_CONFIRM",
   122: "PNR_QUEUE_Q22_TIME_CHANGED",
   123: "PNR_QUEUE_Q23_HX_NOTIFICATION",
};
export const ETaskClosingType = {
   0: "UNKNOWN",
   1: "COMPLETED",
   2: "CANCELED",
   3: "WONT_FIX",
   4: "DUBLICATE",
   5: "UNCOMPLETED",
   "-1": "ALL",
};

export const ETaskSource = {
   0: "UNKNOWN",
   1: "AGENCY",
   2: "ADMIN",
   3: "CRON",
   4: "FLIGHT",
   "-1": "ALL",
};

export const ETaskMedia = {
   0: "UNKNOWN",
   1: "APP",
   2: "CODE",
   3: "CHAT",
   4: "EMAIL",
   "-1": "ALL",
};

export const ETaskVisibility = {
   0: "UNKNOWN",
   1: "EVERYBODY",
   2: "SUPPORT_IT",
   3: "IT",
   "-1": "ALL",
};

export const ETaskPnrReverseReason = {
   0: "UNKNOWN",
   1: "CANCELLATION",
   "-1": "ALL",
};

export const ETaskVoucherReverseReason = {
   0: "UNKNOWN",
   1: "CANCELLATION",
   "-1": "ALL",
};

export const ETaskTnrReverseReason = {
   0: "UNKNOWN",
   1: "CANCELLATION",
   "-1": "ALL",
};

export const ETaskRnrReverseReason = {
   0: "UNKNOWN",
   1: "CANCELLATION",
   "-1": "ALL",
};
